module.exports = __webpack_public_path__ + "static/media/bg_order.7e06ea82.jpg";